<template>
	<default-popup extra-class="ocr-popup">
		<div class="content">
			<div class="icon">
				<i class="fa-thin fa-id-card"></i>
			</div>
			<h2 class="popup-title">{{ $t('forms.require_camera_device') }}</h2>
			<qr-code-box :text="link" v-if="link"/>
			<h3>{{ $t('forms.or_download_app') }}</h3>
			<store-buttons-box/>
			<div class="actions">
				<button class="button style-3" @click.prevent="closePopup">
					<span class="inner">{{ $t('forms.close') }}</span>
				</button>
			</div>
		</div>
	</default-popup>
</template>

<script>
	import DefaultPopup from "./DefaultPopup";
	import StoreButtonsBox from "../containers/StoreButtonsBox";
	import QrCodeBox from "../containers/QrCodeBox";
	import { trackEvent } from '@/analytics';

	export default {
		name: "OcrPopup",
		components: {
			DefaultPopup,
			StoreButtonsBox,
			QrCodeBox,
		},
		props: ['link'],
		data() {
			return {}
		},
		methods: {
			closePopup() {
				this.$store.commit('CLOSE_OCR_POPUP');
			}
		},
		mounted() {
			trackEvent('form_open', { form_name: 'personal_document_ocr', module: 'personal_documents' });
		},
		beforeDestroy() {
			trackEvent('personal_document_ocr_pending_web', { module: 'personal_documents' });
			trackEvent('form_close', { form_name: 'personal_document_ocr', module: 'personal_documents' });
		},
	}
</script>

<style scoped lang="scss">


	h3 {
		font-size: 21px;
	}

	.store-buttons-box {
		margin-bottom: 50px;
		justify-content: center;
	}

	.qr-code-box {
		margin: 50px auto;
	}


</style>